/* eslint-disable */
require('./bold')
require('./chat-group')
require('./close-square')
require('./close')
require('./discord')
require('./dots-vertical')
require('./edit')
require('./image')
require('./instagram')
require('./italic')
require('./link')
require('./lock-open')
require('./lock')
require('./ol')
require('./paragraph')
require('./patreon')
require('./pin')
require('./quote')
require('./redo')
require('./spoiler')
require('./strikethrough')
require('./trash')
require('./twitch')
require('./twitter')
require('./ul')
require('./underline')
require('./undo')
require('./video')
require('./youtube')
